import { z } from "zod";

import { RelationshipToSubscriber } from "@/packages/shared/src/models/coverage";
import { PersonGender } from "@/packages/shared/src/models/person";

export const athenaCoverageSubscriberDetailsSchema = z.object({
  subscriberGivenName: z.string().nullable(),
  subscriberFamilyName: z.string().nullable(),
  subscriberDateOfBirth: z.string().nullable(),
  subscriberSex: z.nativeEnum(PersonGender).nullable(),
  relationshipToSubscriber: z.nativeEnum(RelationshipToSubscriber),
  groupNumber: z.string().nullable(),
});

export const athenaCoverageChoiceSchema = z.object({
  policyKey: z.string().min(1),
});

export const resolveAthenaCoverageSchema = z.object({
  version: z.string().min(1),
  choices: z.array(athenaCoverageChoiceSchema.strict()).min(1).max(2),
});

export const athenaCoverageResolutionAuditSchema = z.object({
  // Previously saved decisions may also include a subscriber selection; ignore that legacy field.
  choices: z.array(athenaCoverageChoiceSchema).min(1).max(2),
  resolvedAt: z.string().datetime(),
  resolvedBy: z.string().min(1),
  coverageFingerprint: z.string().min(1),
});

export const athenaCoverageResolutionPreviewSchema = z.object({
  version: z.string(),
  candidates: z.array(
    z.object({
      key: z.string(),
      source: z.enum(["valerie", "athena"]),
      label: z.string(),
      packageId: z.string().nullable(),
      memberId: z.string().nullable(),
      ...athenaCoverageSubscriberDetailsSchema.shape,
      order: z.number().nullable(),
      casePolicy: z.boolean(),
      selfPay: z.boolean(),
    })
  ),
});

export const athenaCoverageResolutionResponseSchema = z.object({ success: z.literal(true) });
export type AthenaCoverageChoice = z.infer<typeof athenaCoverageChoiceSchema>;
export type ResolveAthenaCoverage = z.infer<typeof resolveAthenaCoverageSchema>;
export type AthenaCoverageResolutionPreview = z.infer<typeof athenaCoverageResolutionPreviewSchema>;
